export default {
    okButton: {
        padding: "6px 30px",
        marginTop: "30px"
    },

    modalBody: {
        padding: "0px 20px 25px 40px"
    },

    referenceInfoContainer: {
        display: "flex",
        rowGap: "5px",
        marginLeft: "20px",
        marginBottom:"5px",
        columnGap: "30px",
    },

    rejectedReason: {
        margin: '7px 55px 0px',
        maxHeight: '250px',
        overflowY: 'scroll'
    },

    gridContainer: {
        marginTop: "20px",
    }
}